"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const callableStopSetInterval = ({ callbacks, entryVars: { intervalId: intervalIdEntry, }, executeProcesses, processor, functionId, }) => {
    try {
        processor.root.stopInterval(intervalIdEntry);
        executeProcesses(undefined, callbacks.done);
    }
    catch (_a) {
        executeProcesses(functionId, callbacks.error, `Invalid internal id: ${intervalIdEntry}. It must to have only numbers`);
    }
};
exports.default = callableStopSetInterval;
